import React from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';

const FeedbackModal = ({ open, isSubmitting, submissionComplete, error, onClose }) => {
  return (
    <Dialog 
      visible={open} 
      onHide={onClose} 
      header="" 
      style={{ width: '300px' }} 
      closable={false} 
      modal
    >
      <div style={{ textAlign: 'center' }}>
        {isSubmitting && (
          <>
            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" animationDuration=".5s" />
            <h6>Processando...</h6>
          </>
        )}
        {submissionComplete && (
          <>
            <i className="pi pi-check" style={{ fontSize: '2em', color: 'green' }}></i>
            <h6>Ação concluída com sucesso!</h6>
          </>
        )}
        {error && (
          <h6 style={{ color: 'red' }}>Erro: {error}</h6>
        )}
      </div>
    </Dialog>
  );
};

export default FeedbackModal;
